<template>
    <div class="antialiased">
      <Sidebar />
      <div class="page">
        <Header></Header>
        <div class="content">
            <div class="container">
                <!-- Page title -->
                <div class="page-header pb-4 border-bottom">
                    <div class="d-flex justify-content-between">
                        <h2 class="page-title">Laporan Service Level Sales MT</h2>
                        <div>
                            <button
                                class="btn btn-white"
                                v-html="ic('filter') + ' Filter'"
                                @click="_filter"
                            >
                            </button>
                        </div>
                    </div>
                </div>
                <div class="alert alert-info" v-if="!isFilter">
                    <i class="fe fe-info mr-2"></i> Pilih filter untuk memuat Laporan Service Level Sales MT
                </div>
                <Nodata v-if="!loading && report.length == 0"/>
                <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loading"/>
                <div class="text-center my-6" v-if="!loading && report.length > 0">
                    <img :src="asset('doc.png')" alt="" style="width: 200px; opacity: .5">
                    <h3 class="my-3" v-html="`${report.length} Data`"></h3>
                    <button class="btn btn-primary" :disabled="isDownload" @click="_createExcel()" v-html="isDownload ? spin() : 'Export Excel'"></button>
                </div>
            </div>
        </div>
      </div>

      <!-- Section Modals -->
      <FormFilter
        :isOpen.sync="modals.filter.view"
        @submit="modals.filter.action"
        />
    </div>
</template>
<script>
import helper from "@/assets/js/helper.js";
import FormFilter from "./modals/filter.vue";

export default {
    name: "LaporanSLASales",
    components: { FormFilter },

    data() {
        return{
            loading: false,
            isFilter: false,
            isDownload: false,
            start_date: '',
            end_date: '',
            report: [],
            modals:{
                filter:{
                    view: false,
                    action: () => {}
                }
            }
        }
    },
    mixins: [helper],
    methods: {
        _filter(){
            this.modals.filter.view = true
            this.modals.filter.action = async (filter) => {
                this.loading = true;
                this.start_date = filter.start_date
                this.end_date = filter.end_date
                this.axios.get("report/service-level/sales-mt", {params: filter})
                    .then((res) => {
                        this.report = [],
                        this.isFilter = true;
                        this.report = res.data.data;
                    })
                    .catch((err) => {
                        this.onError(err);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        async _createExcel(){
            this.isDownload = true;
            const report = this.report.map((laporan) => ({
                "Nama Team": laporan.nama_tim,
                "Nama Salesman": laporan.nama_salesman,
                "Id Toko": laporan.id_toko,
                "No Acc": laporan.no_acc,
                "Nama Outlet": laporan.nama_toko,
                "Week": laporan.week,
                "No Po Manual": laporan.po_manual,
                "Tanggal Terbit PO": '',
                "Tanggal Experied PO": '',
                "Input Tanggal": laporan.tanggal,
                "Approve Tanggal": laporan.approved_date,
                "Delivered Tanggal": laporan.delivered_date,
                "Status": laporan.status,
                "Brand": laporan.nama_brand,
                "Id Barang": laporan.id_barang,
                "Kode Barang": laporan.kode_barang,
                "Nama Barang (SKU)": laporan.nama_barang,
                "QTY PO (CTN)": laporan.in_carton_order,
                "Value PO": laporan.in_value_order,
                "Realisasi PO (Ctn)": laporan.in_carton_realisasi,
                "Realisasi PO (Value)": laporan.in_value_realisasi,
                "SL BY CTN": laporan.service_level_by_ctn + '%',
                "SL BY VALUE": laporan.service_level_by_value + '%',
                "Keterangan": laporan.keterangan,
                "Plan Action": '',
                "Failed Reason": laporan.remark_close,
            }));

            this.createExcel({
                data: report,
                filename: "Laporan Service Level Sales MT pada tanggal " + this.start_date + " - " + this.end_date,
            });
            this.isDownload = false;
        }
    }
}
</script>
